module.exports = __webpack_public_path__ + "static/media/logo-workero-small.30b1228a.png";